function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { times, debounce, last, uniq } from 'lodash';
import { Input } from 'mkui-fd';
import noop from '../_util/noop';
import List from './List';
import { getSearchResult, getFrequentData, getSelectedByCodes } from './util';
var Search = Input.Search;

var Panel = /*#__PURE__*/function (_React$Component) {
  _inherits(Panel, _React$Component);

  /** *******************static************************** */

  /** *******************life cycle************************** */
  function Panel(props) {
    var _this;

    _classCallCheck(this, Panel);

    var hasFrequent = props.hasFrequent,
        _selected = props.selected,
        data = props.data;
    _this = _possibleConstructorReturn(this, _getPrototypeOf(Panel).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "changeHandle", function (item, isLeaf, columnIndex) {
      _this.setState(function (state) {
        var selected = _toConsumableArray(state.selected);

        selected.splice(columnIndex);
        selected.push(item);
        return {
          selected: selected
        };
      }, function () {
        // 点击常用列表
        if (item.valueList) {
          _this.fireChange(item);

          return;
        } // 叶子节点才能触发change


        if (isLeaf) {
          var value = _this.getValue();

          _this.fireChange(value, item);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "searchHandle", function (e) {
      var keywords = e.target.value.trim();

      _this.search(keywords);
    });

    _this.state = {
      data: data || [],
      selected: _selected && _selected.length ? getSelectedByCodes(data, _selected[0].code) : [],
      searchResult: null,
      frequent: hasFrequent ? _this.getFrequent() : null
    };
    _this.search = debounce(_this.search, 200);
    return _this;
  }
  /** *******************handle************************** */


  _createClass(Panel, [{
    key: "search",

    /** *******************inner method************************** */
    value: function search(keywords) {
      var data = this.state.data;

      if (keywords) {
        var result = getSearchResult(data, keywords);
        this.setState({
          searchResult: result
        });
      } else {
        this.setState({
          searchResult: null
        });
      }
    }
  }, {
    key: "getValue",
    value: function getValue() {
      var selected = this.state.selected;
      var valueList = [];
      var labelList = [];
      selected.forEach(function (item) {
        valueList.push(item.value);
        labelList.push(item.label);
      });
      return {
        valueList: valueList,
        labelList: labelList
      };
    }
  }, {
    key: "getListData",
    value: function getListData(columnIndex) {
      var hasFrequent = this.props.hasFrequent;
      var _this$state = this.state,
          selected = _this$state.selected,
          data = _this$state.data,
          frequent = _this$state.frequent;

      if (columnIndex === 0) {
        if (hasFrequent) {
          var frequentData = getFrequentData(data, frequent);
          return [{
            label: '常用',
            value: 'frequent',
            children: frequentData
          }].concat(_toConsumableArray(data));
        }

        return data;
      }

      return selected[columnIndex - 1].children; // return columnIndex === 0 ? data : selected[columnIndex - 1].children;
    }
  }, {
    key: "fireChange",
    value: function fireChange(value, leafData) {
      var _this$props = this.props,
          onSelect = _this$props.onSelect,
          hasFrequent = _this$props.hasFrequent;
      var frequent = this.state.frequent;
      onSelect([{
        code: value.valueList,
        name: value.labelList.join(' / ')
      }], leafData);

      if (hasFrequent) {
        this.updateFrequent(frequent, value);
      }
    }
  }, {
    key: "updateFrequent",
    value: function updateFrequent(frequent, value) {
      var newFrequent = uniq([last(value.valueList)].concat(_toConsumableArray(frequent)));

      if (newFrequent.length > 10) {
        newFrequent.pop();
      }

      this.setState({
        frequent: newFrequent
      });
      this.setFrequent(newFrequent);
    }
  }, {
    key: "getFrequent",
    value: function getFrequent() {
      var _this$props2 = this.props,
          defaultFrequent = _this$props2.defaultFrequent,
          frequentStorageKey = _this$props2.frequentStorageKey;
      return JSON.parse(localStorage.getItem(frequentStorageKey)) || defaultFrequent;
    }
  }, {
    key: "setFrequent",
    value: function setFrequent(value) {
      var frequentStorageKey = this.props.frequentStorageKey;
      localStorage.setItem(frequentStorageKey, JSON.stringify(value));
    }
    /** *******************render************************** */

  }, {
    key: "renderSearchResult",
    value: function renderSearchResult() {
      var _this2 = this;

      var prefixCls = this.props.prefixCls;
      var searchResult = this.state.searchResult;
      return React.createElement("ul", {
        className: "".concat(prefixCls, "-search-result")
      }, searchResult.map(function (item) {
        return React.createElement("li", {
          key: item.valueList.join('-'),
          onClick: function onClick() {
            _this2.fireChange(item);
          }
        }, _toConsumableArray(item.labelList).reverse().join('，'));
      }));
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      var _this3 = this;

      var _this$props3 = this.props,
          prefixCls = _this$props3.prefixCls,
          columns = _this$props3.columns;
      var _this$state2 = this.state,
          data = _this$state2.data,
          selected = _this$state2.selected;
      return React.createElement("div", {
        className: "".concat(prefixCls, "-content")
      }, data.length ? times(columns, function (columnIndex) {
        return React.createElement("div", {
          key: "column-".concat(columnIndex)
        }, columnIndex === 0 || selected[columnIndex - 1] ? React.createElement(List, {
          data: _this3.getListData(columnIndex),
          value: selected[columnIndex],
          onChange: function onChange(item, isLeaf) {
            return _this3.changeHandle(item, isLeaf, columnIndex);
          }
        }) : null);
      }) : null);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          prefixCls = _this$props4.prefixCls,
          searchPlaceholder = _this$props4.searchPlaceholder;
      var searchResult = this.state.searchResult;
      return React.createElement("div", {
        className: classNames("".concat(prefixCls))
      }, React.createElement("div", {
        className: "".concat(prefixCls, "-search")
      }, React.createElement(Search, {
        className: "".concat(prefixCls, "-search-input"),
        placeholder: searchPlaceholder,
        onChange: this.searchHandle
      })), searchResult ? this.renderSearchResult() : this.renderContent());
    }
  }]);

  return Panel;
}(React.Component);

_defineProperty(Panel, "propTypes", {
  prefixCls: PropTypes.string,
  onSelect: PropTypes.func,
  data: PropTypes.array,
  columns: PropTypes.number,
  hasFrequent: PropTypes.bool,
  defaultFrequent: PropTypes.array,
  frequentStorageKey: PropTypes.string,
  searchPlaceholder: PropTypes.string
});

_defineProperty(Panel, "defaultProps", {
  prefixCls: 'mkui-cascader-select-panel',
  onSelect: noop,
  data: null,
  columns: 4,
  hasFrequent: false,
  defaultFrequent: [],
  frequentStorageKey: '',
  searchPlaceholder: ''
});

export default Panel;
//# sourceMappingURL=Panel.js.map
